export const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp'];
export const EXCEL_EXTENSIONS = ['xlsx', 'xls'];
